<template>
  <b-overlay
    :show='loading'
    rounded
    opacity='0.7'
    spinner-small
    spinner-variant='primary'
    class='w-100 mt-5'
  >
    <template v-slot:overlay>
      <div class="text-center loading" >
        <b-spinner style="width: 3rem; height: 3rem;" variant='primary' label="Large Spinner"></b-spinner>
        <h6 class='text-primary'>Buscando fatura...</h6>
      </div>
    </template>
  </b-overlay>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'RedirectInvoice',
  components: {  },
  computed:{

  },
  data() {
    return {
      loading: true,
    }
  },
  methods: {
    ...mapActions('userPlans', {
      handleGetInvoice: 'handleGetInvoice'
    }),
  },
  async mounted() {
    this.loading = true
    const { id } = this.$route.query
    const { secure_url } = await this.handleGetInvoice(id)
    this.loading = false
    window.location.replace(secure_url)
  }
}
</script>

<style scoped>

</style>
